import useFlags from 'src/utils/useFlagWrapper';
import { FLAG_KEYS } from 'src/constants/launchDarklyFlagKeys';
import { useShellRootContext } from 'src/contexts/ShellRoot';
import {
  useMultiUiBrandContext,
  UiTheme
} from '@jarvis/react-setup-and-onboarding-addons';

export const useFinishingSetupScreenConfig = () => {
  const {
    interfaces: { v1 }
  } = useShellRootContext();
  const featureFlags = useFlags();
  const { uiBrand } = useMultiUiBrandContext();

  // Load Launch Darkly flag to determine if we should should use the loading UI
  const shouldUseFinishingSetupScreenLoading =
    !!featureFlags[FLAG_KEYS.ENABLE_USE_FINISHING_SETUP_SCREEN_LOADING];

  // If the ENABLE_USE_FINISHING_SETUP_SCREEN_LOADING flag is enabled, on OD flows inside HPX (i.e. uiBrand is HPX and application context is NATIVE_PORTAL,
  // not NATIVE_APP), we should use the new finishing setup loading. If disabled, will use the default behavior of lottie animation. Currently, the default
  // is to not show the new UI on NATIVE_PORTAL because the /login route shows a loading spinner. Showing the new UI would cause a visual flickering.
  const isNativeApp = v1.app?.getApplicationContext?.() === 'NATIVE_APP';
  const shouldUseNativeFlowUI = shouldUseFinishingSetupScreenLoading
    ? uiBrand === UiTheme.hpx || isNativeApp
    : isNativeApp;

  return { shouldUseNativeFlowUI };
};
